import React, { useState } from 'react';
import MessageShortcut from './Msg-Shortcut/MessageShortcut';
import ItemShortcut from './Msg-Shortcut/ItemShortcut';
import MessageShortcutEng from './Msg-Shortcut/MessageShortcutEN';
import TheRefineryTools from './Msg-Shortcut/RefineryTools';
import TheFAQOligio from './Msg-Shortcut/FAQOligio';
import TheFAQUltraformer from './Msg-Shortcut/FAQUltraformer';
import TheFAQAtiere from './Msg-Shortcut/FAQAtiere';

export default function MsgShortcut({
  onBack,
  onSendImage,
  selectedCustomer,
  selectedUserId,
  userId, // ✅ เพิ่มบรรทัดนี้
}) {
  const [selectedShortcut, setSelectedShortcut] = useState(null);

  return (
    <div className="relative max-w-screen-xl mx-auto px-4">
      {!selectedShortcut ? (
        <>
          <div className="flex items-center gap-3 mt-[-2px] mb-4">
            <h3 className="text-lg font-semibold">Shortcut Options</h3>
            <button
              onClick={onBack}
              className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition"
            >
              ← Back to Main Asset
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <button
              onClick={() => setSelectedShortcut('message')}
              className="w-full border rounded-lg py-3 px-4 text-sm font-medium hover:bg-gray-50 transition"
            >
              Message Shortcut (Thai)
            </button>

            <button
              onClick={() => setSelectedShortcut('message-eng')}
              className="w-full border rounded-lg py-3 px-4 text-sm font-medium hover:bg-gray-50 transition"
            >
              Message Shortcut (Eng)
            </button>

            <button
              onClick={() => setSelectedShortcut('refinerytools')}
              className="w-full border rounded-lg py-3 px-4 text-sm font-medium hover:bg-gray-50 transition"
            >
              Refinery Tools (Helper)
            </button>

            <button
              onClick={() => setSelectedShortcut('item')}
              className="w-full border rounded-lg py-3 px-4 text-sm font-medium hover:bg-gray-50 transition"
            >
              Item Shortcut (Card)
            </button>

            <button
              onClick={() => setSelectedShortcut('faq-oligio')}
              className="w-full border rounded-lg py-3 px-4 text-sm font-medium hover:bg-gray-50 transition"
            >
              FAQ (Oligio)
            </button>

            <button
              onClick={() => setSelectedShortcut('faq-ultraformer')}
              className="w-full border rounded-lg py-3 px-4 text-sm font-medium hover:bg-gray-50 transition"
            >
              FAQ (Ultraformer)
            </button>

            <button
              onClick={() => setSelectedShortcut('faq-atiere')}
              className="w-full border rounded-lg py-3 px-4 text-sm font-medium hover:bg-gray-50 transition"
            >
              FAQ (Atiere)
            </button>

          </div>
        </>
      ) : selectedShortcut === 'message' ? (
        <MessageShortcut
          onBack={() => setSelectedShortcut(null)}
          userId={selectedUserId}
          selectedCustomer={selectedCustomer}
        />
      ) : selectedShortcut === 'message-eng' ? (
        <MessageShortcutEng
          onBack={() => setSelectedShortcut(null)}
          userId={selectedUserId}
          selectedCustomer={selectedCustomer}
        />  
      ) : selectedShortcut === 'refinerytools' ? (
        <TheRefineryTools
          onBack={() => setSelectedShortcut(null)}
          userId={selectedUserId}
          selectedCustomer={selectedCustomer}
        />    
      ) : selectedShortcut === 'item' ? (
        <ItemShortcut
          onBack={() => setSelectedShortcut(null)}
          userId={selectedUserId}
          selectedCustomer={selectedCustomer}
        />
       ) : selectedShortcut === 'faq-oligio' ? (
        <TheFAQOligio
          onBack={() => setSelectedShortcut(null)}
          userId={selectedUserId}
          selectedCustomer={selectedCustomer}
        />
      ) : selectedShortcut === 'faq-ultraformer' ? (
        <TheFAQUltraformer
          onBack={() => setSelectedShortcut(null)}
          userId={selectedUserId}
          selectedCustomer={selectedCustomer}
        />     
      ) : selectedShortcut === 'faq-atiere' ? (
        <TheFAQAtiere
          onBack={() => setSelectedShortcut(null)}
          userId={selectedUserId}
          selectedCustomer={selectedCustomer}
        />                  

      ) : null}
    </div>
  );
}
